import useMartyContext from 'hooks/useMartyContext';
import { PROVIDE_REFUND_OPTIONS } from 'constants/exchanges';
import { evRefundMethodClick } from 'events/returns';
import { REFUND_METHOD_TYPE } from 'constants/amethystEnums';
import { track } from 'apis/amethyst';

interface ReturnStoreCreditProps {
  onLabelPaymentTypeSelect: (paymentType: string) => void;
  labelPaymentType?: string | null;
}

const ReturnStoreCredit = ({ onLabelPaymentTypeSelect, labelPaymentType }: ReturnStoreCreditProps) => {
  const { testId } = useMartyContext();

  const handleRefundMethodSelect = (paymentType: string) => {
    track(() => [
      evRefundMethodClick,
      {
        refundMethod: REFUND_METHOD_TYPE[paymentType]
      }
    ]);
    onLabelPaymentTypeSelect(paymentType);
  };

  return (
    <div className="mb-8">
      <div className="mb-8 sm:mt-8 md:mt-1">
        <h2 id="return-method-title" className="mt-1 md:mt-4">
          How would you like your refund issued?
        </h2>
      </div>
      <div className="mt-4 flex flex-col text-sm md:flex-row md:gap-4" role="radiogroup" aria-labelledby="return-method-title">
        <label
          className={`mb-4 flex cursor-pointer flex-col rounded-lg border p-6 md:mb-0 md:w-1/2 ${
            labelPaymentType === PROVIDE_REFUND_OPTIONS.ORIGINAL_PAYMENT ? 'border-base bg-default-subtle shadow-sm' : 'border-subtle'
          }`}
          htmlFor="originalPayment"
        >
          <div className="flex">
            <input
              id="originalPayment"
              data-test-id={testId('originalPaymentInput')}
              type="radio"
              name="PaymentType"
              value={PROVIDE_REFUND_OPTIONS.ORIGINAL_PAYMENT}
              checked={labelPaymentType === PROVIDE_REFUND_OPTIONS.ORIGINAL_PAYMENT}
              onChange={e => handleRefundMethodSelect(e.target.value)}
              className="accent mr-3 h-[18px] w-[18px] shrink-0 border-moderate"
            />
            <div className="flex flex-col">
              <span className="text-sm">Original Form of Payment</span>
            </div>
          </div>
        </label>
        <label
          className={`flex cursor-pointer flex-col rounded-lg border p-6 md:w-1/2 ${
            labelPaymentType === PROVIDE_REFUND_OPTIONS.STORE_CREDIT ? 'border-base bg-default-subtle shadow-sm' : 'border-subtle'
          }`}
          htmlFor="storeCredit"
        >
          <div className="flex">
            <input
              id="storeCredit"
              data-test-id={testId('storeCreditInput')}
              type="radio"
              name="PaymentType"
              value={PROVIDE_REFUND_OPTIONS.STORE_CREDIT}
              checked={labelPaymentType === PROVIDE_REFUND_OPTIONS.STORE_CREDIT}
              onChange={e => handleRefundMethodSelect(e.target.value)}
              className="accent mr-3 h-[18px] w-[18px] shrink-0 border-moderate"
            />
            <div className="flex flex-col">
              <span className="text-sm">Store Credit</span>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default ReturnStoreCredit;
